// filters is an array of strings to selectively choose fields from BE
export const enumToObject = <T extends string>(enumVariable: { [key in T]: string }, filters: string[] = []) => {
    if (filters.length > 0) {
        return Object.fromEntries(Object.entries<string>(enumVariable).filter(([, value]) => filters.includes(value)));
    }
    return Object.fromEntries(Object.entries<string>(enumVariable));
};
